import Album from "./Album";
import { useFetchAlbumsQuery } from "../store";
import { useAddAlbumsMutation } from "../store";
import { faker } from "@faker-js/faker";

const AlbumsList = ({ user, children }) => {
  const { data, isError, isLoading } = useFetchAlbumsQuery(user);
  // console.log(useFetchAlbumsQuery(user).data);
  const [addAlbum, isLoadingObject] = useAddAlbumsMutation();
  // console.log(addAlbum);
  // console.log(isLoadingObject.isLoading);
  // console.log(useAddAlbumsMutation());

  const handleAddAlbum = (e) => {
    // add Album
    let album = {
      usrId: user.id,
      name: faker.commerce.productName(),
    };
    addAlbum(album);
  };

  let contentButton;
  if (isLoadingObject.isLoading) {
    contentButton = "...";
  } else {
    contentButton = "Add Album";
  }

  let content;
  if (isLoading) {
    content = "...";
  } else if (isError) {
    content = "There was an error fetching data";
  } else {
    const updatedData = data.map((album, i) => {
      return <Album key={album.id}>{album}</Album>;
    });
    content = updatedData;
  }

  return (
    <div className="flex flex-col px-4 mx-4 my-2 border-black border-x">
      <div className="flex flex-row items-center justify-between border-b mb-4 pb-2">
        <span>Albums</span>
        <button onClick={handleAddAlbum} className="border p-2">
          {contentButton}
        </button>
      </div>
      {/* <div>{children}</div> */}
      {/* <Album></Album>
      <Album></Album> */}
      {content}
    </div>
  );
};

export default AlbumsList;
